export default __webpack_public_path__ + "static/media/AutoWF2.3ebbb2e2.png";